// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgStarOnSquareIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M18.482 6.827c1.857 0 2.804.922 2.804 2.748v8.972c0 1.825-.947 2.747-2.804 2.747H9.518c-1.866 0-2.803-.922-2.803-2.747V9.575q.002-2.75 2.803-2.748zm-4.036 3.148c-.16-.497-.723-.497-.883 0l-.813 2.517-2.651-.017c-.554-.01-.688.566-.278.859l2.161 1.533-.848 2.509c-.17.505.295.843.732.515L14 16.339l2.143 1.552c.437.328.902-.01.732-.515l-.848-2.509 2.16-1.533c.402-.284.277-.868-.276-.86l-2.661.018z"
    />
    <path d="M14.152 2.724c1.857 0 2.803.922 2.803 2.748v.15H9.518C6.982 5.622 5.5 7.067 5.5 9.575v7.615h-.313c-1.865 0-2.803-.922-2.803-2.748v-8.97c0-1.826.938-2.748 2.804-2.748z" />
  </g>
);
export default SvgStarOnSquareIcon;
SvgStarOnSquareIcon.displayName = 'SvgStarOnSquareIcon';
